<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        dense
        :search="search"
        sort-by="createdAt"
        sort-desc
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row class="mt-2">
              <v-col cols="12" sm="12" md="8" lg="8">
                <v-text-field
                  flat
                  dense
                  outlined
                  background-color="white"
                  v-model="search"
                  placeholder="search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="$rbac.can('settlement.approve')"
                      color="success"
                      v-on="on"
                      dark
                      rounded
                      @click="openConfirmation"
                    >
                      <v-icon>
                        mdi-content-save
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Save Checklist</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ items.map(x => x).indexOf(item) + 1 }}
        </template>
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
        <template v-slot:item.bankAccountNumber="{ item }">
          {{ accountNumber(item) }}
        </template>
        <template v-slot:item.totalAmount="{ item }">
          {{ formatPrice(item.totalAmount) }}
        </template>
        <template v-slot:item.totalUseAmount="{ item }">
          {{ formatPrice(item.totalUseAmount) }}
        </template>
        <template v-slot:item.totalRemainAmount="{ item }">
          {{ formatPrice(item.totalRemainAmount) }}
        </template>
        <template v-slot:item.pphAmount="{ item }">
          {{ formatPrice(item.pphAmount) }}
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-col cols="12" class="text-center">
            <v-checkbox v-model="item.approved"></v-checkbox>
          </v-col>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <DialogConfirmation
      :dialog="dialog"
      :items="filteredItems"
      :loading="loading"
      @close="close"
      @save="saveChecklist"
    ></DialogConfirmation>
  </v-row>
</template>

<script>
import moment from "moment";
import DialogConfirmation from "./DialogConfirmation.vue";

export default {
  name: "checklist-settlement-kasbon",
  components: {
    DialogConfirmation,
  },
  data: () => ({
    dialog: false,
    loading: false,
    items: [],
    headers: [
      {
        id: 1,
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Date",
        value: "date",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "Kasbon Number",
        value: "kasbonNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Kasbon Name",
        value: "name",
        sortable: false,
        align: "start",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Bank Account Number",
        value: "bankAccountNumber",
        sortable: false,
        align: "start",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Total",
        value: "totalAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 7,
        text: "Total Use",
        value: "totalUseAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 8,
        text: "Total Remain",
        value: "totalRemainAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 8,
        text: "Total PPH",
        value: "pphAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 8,
        text: "Created Date",
        value: "createdAt",
        sortable: true,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 8,
        text: "Action",
        value: "action",
        sortable: true,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    search: "",
  }),

  computed: {
    filteredItems() {
      return this.items.filter(item => item.approved === true);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("settlementKasbon/getApproval")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-yyyy");
    },
    openConfirmation() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    saveChecklist(data) {
      this.loading = true;
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("settlementKasbon/saveApproval", data)
        .then(() => {
          this.$store.commit("SET_LOADER", false);
          this.dialog = false;
          this.loading = false;
          this.initialize();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
          this.loading = false;
        });
    },
    accountNumber(item) {
      if (item.external) {
        return item.externalAccountNumber.accountNumber;
      } else {
        return item.bankAccountNumber;
      }
    },
  },
};
</script>

<style></style>
